export default "__VITE_ASSET___q9aTr1j__"